// extracted by mini-css-extract-plugin
export default {"select":"style_select__ETbTJ","option":"style_option__FRZiC","option_info":"style_option_info__F6k8A","percent_bar":"style_percent_bar__jOy31"};